import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from "react";
import Loading from "./components/Loading";
import LoadingContext from "./contexts/Loading";
import { RouterManager } from "./routes/RouterManager";
export const App = () => {
    const [isLoading, setIsLoading] = useState(false);
    const obj = useMemo(() => ({ isLoading, setIsLoading }), [isLoading]);
    return (_jsx(LoadingContext.Provider, { value: obj, children: _jsx("div", { className: "flex flex-col", children: _jsxs("div", { className: "font-montserrat", children: [_jsx(RouterManager, {}), _jsx(Loading, {})] }) }) }));
};
